import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

/**
 * ManageTagsService
 */
@Injectable({
  providedIn: 'root'
})
export class ManageTagsService {
  /**
   * Subject
   *
   * @type {BehaviorSubject<boolean>}
   * @private
   */
  private subject: BehaviorSubject<boolean> = new BehaviorSubject(false);

  /**
   * Check if the tags were changed
   *
   * @type {Observable<boolean>}
   */
  isTagsChanged: Observable<boolean> = this.subject.asObservable();

  /**
   * Tag changed
   *
   * @param {boolean} flag
   * @return {void}
   */
  tagsChanged(flag: boolean): void {
    this.subject.next(flag)
  }
}
